import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import UIModal from 'UIComponents/dialog/UIModal';
import UIWizard from 'UIComponents/dialog/UIWizard';
import { WizardHeaderWithOverview } from 'foundations-components/transitional/components/Wizard';
import UIWizardStep from 'UIComponents/dialog/UIWizardStep';
import { UNINITIALIZED, REGISTER_SMS, VERIFY_SMS, VERIFICATION_SUCCESSFUL, CHANGE_SECURITY_NUMBER } from '../../constants/security/SecurityPhoneNumberSetupSteps';
import { indexOfStep } from '../../constants/security/SecurityPhoneNumberSetupStepOrder';
import { getSetupStep, getShouldBlockSetupProgress, getStagedSMSNumber, getVerificationCodeAttempt } from '../../selectors/security/SecurityPhoneNumberSetupSelector';
import { completeSetup, cancelSetup, configureSms, codeAttempt, changeSecurityNumber } from '../../actions/security/SecurityPhoneNumberActions';
import { requestTwoFactorAuthStatus } from '../../actions/TwoFactorAuthActions';
import RegisterSMSStepContainer from '../../containers/security/RegisterSMSStepContainer';
import VerifyAuthStepContainer from '../../containers/security/VerifyAuthStepContainer';
import SecurityPhoneNumberSuccess from '../../components/security/SecurityPhoneNumberSuccess';
import { getSecurityPhoneNumber } from '../../selectors/security/SecurityPhoneNumberSelector';
import SecurityPhoneNumberRecord from '../../records/security/SecurityPhoneNumber';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class SecurityPhoneNumberSetup extends Component {
  constructor(...args) {
    super(...args);
    this.onStepIndexChange = () => {
      const {
        step,
        smsNumber,
        verificationCodeAttempt,
        securityPhoneNumber
      } = this.props;
      switch (step) {
        case REGISTER_SMS:
          this.props.configureSms(smsNumber);
          break;
        case VERIFY_SMS:
          this.props.codeAttempt(securityPhoneNumber, verificationCodeAttempt);
          break;
        case CHANGE_SECURITY_NUMBER:
          this.props.changeSecurityNumber(smsNumber);
          break;
        // no default
      }
    };
  }
  render() {
    return /*#__PURE__*/_jsx(UIModal, {
      use: "fullscreen",
      children: /*#__PURE__*/_jsxs(UIWizard, {
        defaultHeading: I18n.text('userPreferences.securityPhoneNumber.title'),
        defaultCancelLabel: I18n.text('userPreferences.2fa.wizardNextButtonLabels.cancel'),
        defaultDoneLabel: I18n.text('userPreferences.2fa.wizardNextButtonLabels.done'),
        headerComponent: WizardHeaderWithOverview,
        backable: false,
        stepIndex: indexOfStep(this.props.step),
        disablePrimaryButton: this.props.shouldBlockSetupProgress,
        onStepIndexChange: this.onStepIndexChange,
        onConfirm: () => {
          this.props.completeSetup();
          this.props.requestTwoFactorAuthStatus();
        },
        onReject: this.props.cancelSetup,
        cancellable: true,
        stickyHeader: false,
        "data-test-id": "security-phone-number-wizard",
        children: [/*#__PURE__*/_jsx(UIWizardStep, {
          name: I18n.text(`userPreferences.2fa.${REGISTER_SMS}.stepName`),
          children: /*#__PURE__*/_jsx(RegisterSMSStepContainer, {})
        }, REGISTER_SMS), /*#__PURE__*/_jsx(UIWizardStep, {
          name: I18n.text(`userPreferences.2fa.${REGISTER_SMS}.stepName`),
          children: /*#__PURE__*/_jsx(RegisterSMSStepContainer, {})
        }, CHANGE_SECURITY_NUMBER), /*#__PURE__*/_jsx(UIWizardStep, {
          name: I18n.text(`userPreferences.2fa.${VERIFY_SMS}.stepName`),
          children: /*#__PURE__*/_jsx(VerifyAuthStepContainer, {})
        }, VERIFY_SMS), /*#__PURE__*/_jsx(UIWizardStep, {
          children: /*#__PURE__*/_jsx(SecurityPhoneNumberSuccess, {})
        }, VERIFICATION_SUCCESSFUL)]
      })
    });
  }
}
SecurityPhoneNumberSetup.propTypes = {
  step: PropTypes.oneOf([UNINITIALIZED, REGISTER_SMS, VERIFY_SMS, VERIFICATION_SUCCESSFUL, CHANGE_SECURITY_NUMBER]).isRequired,
  shouldBlockSetupProgress: PropTypes.bool.isRequired,
  smsNumber: PropTypes.string.isRequired,
  verificationCodeAttempt: PropTypes.string.isRequired,
  completeSetup: PropTypes.func.isRequired,
  requestTwoFactorAuthStatus: PropTypes.func.isRequired,
  cancelSetup: PropTypes.func.isRequired,
  configureSms: PropTypes.func.isRequired,
  codeAttempt: PropTypes.func.isRequired,
  changeSecurityNumber: PropTypes.func.isRequired,
  securityPhoneNumber: PropTypes.instanceOf(SecurityPhoneNumberRecord).isRequired
};
function mapStateToProps(state) {
  return {
    step: getSetupStep(state),
    shouldBlockSetupProgress: getShouldBlockSetupProgress(state),
    smsNumber: getStagedSMSNumber(state),
    verificationCodeAttempt: getVerificationCodeAttempt(state),
    securityPhoneNumber: getSecurityPhoneNumber(state)
  };
}
export default connect(mapStateToProps, {
  completeSetup,
  requestTwoFactorAuthStatus,
  cancelSetup,
  configureSms,
  codeAttempt,
  changeSecurityNumber
})(SecurityPhoneNumberSetup);